/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

var _ = require('underscore');

module.exports = function() {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetAllUserComplianceRegistrations: {
        $xmlns: 'http://dobs.pa.gov/sc/usercomplianceregistration/bpm/1.0'
      }
    },
    blueprintArrays: ['GetAllUserComplianceRegistrationsResponse.SC_UserComplianceRegistration'],
    blueprint: {
      complianceRegistrations: [
        '$..SC_UserComplianceRegistration',
        {
          userComplianceRegistrationId: '$..ID',
          firstName: '$..FirstName',
          lastName: '$..LastName',
          title: '$..Title',
          professionalTypeID: '$..ProfessionalTypeID',
          organization: '$..Organization',
          addressID: '$..AddressID',
          phone: '$..Phone',
          email: '$..Email',
          specialAccommodations: '$..SpecialAccommodations',
          dietaryRestrictions: '$..DietaryRestrictions',
          paab: '$..PAAB',
          pacleb: '$..PACLEB',
          cfpbos: '$..CFPBOS',
          padoi: '$..PADOI',
          accfc: '$..ACCFC',
          isPaid: '$..IsPaid',
          userID: '$..UserID',
          addressLine1: '$..AddressLine1',
          addressLine2: '$..AddressLine2',
          city: '$..City',
          county: '$..County',
          state: '$..State',
          postalCode: '$..PostalCode',
          country: '$..Country',
          professionalType: '$..ProfessionalType',
          year: '$..Year',
          isInternal: '$..IsInternal'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      _.each(response.complianceRegistrations, function(complianceRegistration) {
        complianceRegistration.organization = complianceRegistration.organization || '--';
        complianceRegistration.isInternalRegistration = complianceRegistration.isInternal === '1' ? true : false;
      });
      deferred.resolve(response.complianceRegistrations);
    })
    .fail(function(err) {
      deferred.reject(err);
    });

  return deferred.promise();
};
